// ─── NAV SCROLL ───
(function () {
  const nav = document.getElementById('mainNav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.classList.toggle('scrolled', window.scrollY > 80);
    });
  }
})();

// ─── MOBILE MENU ───
(function () {
  const btn = document.getElementById('navHamburger');
  const menu = document.getElementById('mobileMenu');
  if (!btn || !menu) return;

  function closeMenu() {
    btn.classList.remove('open');
    menu.classList.remove('open');
    btn.setAttribute('aria-expanded', 'false');
    menu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function openMenu() {
    btn.classList.add('open');
    menu.classList.add('open');
    btn.setAttribute('aria-expanded', 'true');
    menu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  btn.addEventListener('click', () => {
    if (menu.classList.contains('open')) closeMenu();
    else openMenu();
  });

  menu.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', closeMenu);
  });
})();

// ─── SCROLL REVEAL ───
(function () {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) e.target.classList.add('visible');
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

  document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
})();

// ─── PRODUCT FILTER ───
const allCards = document.querySelectorAll('.product-card');
const countEl = document.getElementById('productCount');

function filterProducts(cat, tabEl) {
  if (tabEl) {
    document.querySelectorAll('.cat-tab').forEach(t => t.classList.remove('active'));
    tabEl.classList.add('active');
  } else {
    document.querySelectorAll('.cat-tab').forEach(t => {
      if (t.getAttribute('onclick') && t.getAttribute('onclick').includes("'" + cat + "'")) {
        document.querySelectorAll('.cat-tab').forEach(x => x.classList.remove('active'));
        t.classList.add('active');
      }
    });
  }

  let visible = 0;
  allCards.forEach(card => {
    const cats = card.getAttribute('data-category') || '';
    const show = (cat === 'all') || cats.includes(cat);
    card.style.display = show ? '' : 'none';
    if (show) visible++;
  });
  if (countEl) {
    countEl.textContent = 'Showing ' + visible + ' piece' + (visible !== 1 ? 's' : '');
  }

  setTimeout(() => {
    document.querySelectorAll('.product-card:not([style*="none"]) .reveal').forEach(el => {
      if (!el.classList.contains('visible')) el.classList.add('visible');
    });
  }, 100);
}

// ─── SMOOTH ANCHOR ───
document.querySelectorAll('a[href^="#"]').forEach(a => {
  a.addEventListener('click', e => {
    const target = document.querySelector(a.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });
    }
  });
});

// ─── CART: PROPER AJAX UPDATE (Shopify Cart API) ───
(function () {
  const cartForm = document.getElementById('cart-form');
  if (!cartForm) return;

  const messageEl = document.getElementById('cart-update-message');
  let debounceTimer = null;
  let isUpdating = false;

  function formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    // Prefer Shopify global helper when available
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.themeMoneyFormat);
    }
    // Manual format using shop money_format (e.g. "Rs.{{amount}}")
    var format = window.themeMoneyFormat || 'Rs.{{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    value = parts.join('.');
    // Support common Shopify tokens
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, parts[0].replace(/,/g, '.'));
  }

  function showMessage(msg, isError) {
    if (!messageEl) return;
    messageEl.textContent = msg;
    messageEl.style.display = 'block';
    messageEl.style.color = isError ? '#c0392b' : 'var(--gold)';
    if (!isError) {
      setTimeout(() => {
        messageEl.style.display = 'none';
      }, 2500);
    }
  }

  function hideMessage() {
    if (!messageEl) return;
    messageEl.style.display = 'none';
    messageEl.textContent = '';
  }

  function updateCartCount(count) {
    const el = document.getElementById('cart-count');
    if (el) el.textContent = count;
  }

  function updateLineUI(key, quantity, linePrice, cartTotal, itemCount) {
    const row = document.querySelector('tr[data-key="' + key + '"]');
    if (!row) return;

    if (quantity <= 0) {
      row.style.transition = 'opacity 0.3s ease';
      row.style.opacity = '0';
      setTimeout(() => row.remove(), 300);
    } else {
      const input = row.querySelector('[data-cart-quantity-input]');
      if (input) input.value = quantity;
      const totalCell = row.querySelector('.cart-line-total');
      if (totalCell && typeof linePrice === 'number') {
        totalCell.textContent = formatMoney(linePrice);
      }
    }

    const subtotalEl = document.getElementById('cart-subtotal');
    if (subtotalEl && typeof cartTotal === 'number') {
      subtotalEl.textContent = formatMoney(cartTotal);
    }
    if (typeof itemCount === 'number') {
      updateCartCount(itemCount);
    }
  }

  function changeQuantity(key, quantity) {
    if (isUpdating) return;
    isUpdating = true;
    hideMessage();

    // Shopify Cart Change API — uses line item key
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      }),
      credentials: 'same-origin'
    })
      .then(res => {
        if (!res.ok) throw new Error('Update failed');
        return res.json();
      })
      .then(cart => {
        // Find the updated item (or confirm removal)
        const item = (cart.items || []).find(i => i.key === key);
        const linePrice = item ? item.final_line_price : 0;
        const qty = item ? item.quantity : 0;

        updateLineUI(key, qty, linePrice, cart.total_price, cart.item_count);

        // If cart is empty, reload to show empty state
        if (cart.item_count === 0) {
          window.location.reload();
          return;
        }
      })
      .catch(() => {
        showMessage('Could not update your cart. Please try again.', true);
      })
      .finally(() => {
        isUpdating = false;
      });
  }

  function attachListeners() {
    // Quantity input change
    document.querySelectorAll('[data-cart-quantity-input]').forEach(input => {
      input.addEventListener('change', function () {
        const key = this.getAttribute('data-key');
        let qty = parseInt(this.value, 10);
        if (isNaN(qty) || qty < 0) qty = 0;
        this.value = qty;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => changeQuantity(key, qty), 300);
      });

      // Prevent form submit on Enter in qty field
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.blur();
        }
      });
    });

    // Minus buttons
    document.querySelectorAll('.qty-minus').forEach(btn => {
      btn.addEventListener('click', function () {
        const key = this.getAttribute('data-key');
        const input = document.querySelector('input[data-key="' + key + '"]');
        if (!input) return;
        let qty = parseInt(input.value, 10) || 0;
        qty = Math.max(0, qty - 1);
        input.value = qty;
        changeQuantity(key, qty);
      });
    });

    // Plus buttons
    document.querySelectorAll('.qty-plus').forEach(btn => {
      btn.addEventListener('click', function () {
        const key = this.getAttribute('data-key');
        const input = document.querySelector('input[data-key="' + key + '"]');
        if (!input) return;
        let qty = parseInt(input.value, 10) || 0;
        qty = qty + 1;
        input.value = qty;
        changeQuantity(key, qty);
      });
    });

    // Remove buttons
    document.querySelectorAll('.cart-remove-btn').forEach(btn => {
      btn.addEventListener('click', function () {
        const key = this.getAttribute('data-key');
        changeQuantity(key, 0);
      });
    });
  }

  attachListeners();
})();
